import Logger from '@KrashidBuilt/common/utils/logger';

const logger = new Logger('image');

const getImgHeightWidth = (src) => new Promise((resolve, reject) => {
    let img = new Image();
    img.src = src;
    img.onload = (e) => {
        const image = e.target;
        resolve({
            width: image.width,
            height: image.height
        });
    };
    img.onerror = (error) => {
        reject(error);
    };
});

const shouldRotate = async (src) => {
    try {
        const dimensions = await getImgHeightWidth(src);
        // this is taller than it is wide, so we should rotate it
        return dimensions.width < dimensions.height;
    } catch (error) {
        logger.error(error);
    }
    return false;
};

export default {
    getImgHeightWidth,
    shouldRotate
};